export const MifosDateFormats = {
  dd_MMMM_yyyy : "dd MMMM yyyy",
  yyyy : "yyyy",
};
